import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRight, Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { teamPrograms } from '../data/teamPrograms';
import { TeamLogo } from './TeamLogo';

const TeamCard = ({ program, index }) => {
  const { user, hasAccess } = useAuth();
  const unlocked = user && hasAccess(program.id);
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.32 + index * 0.05 }}
      className="bg-[#f5efe4] border border-stone-200 rounded-2xl overflow-hidden"
      data-testid={`team-card-${program.id}`}
    >
      <div className="flex items-center gap-5 p-5 md:p-6">
        <div className="flex-shrink-0 bg-white rounded-xl p-2 border border-stone-200">
          <TeamLogo program={program} size="w-20 h-20" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[11px] font-body text-[#8a6a5a] uppercase tracking-[0.25em] mb-1">Team Program</p>
          <h2 className="font-heading text-2xl text-forest mb-1">{program.title}</h2>
          <p className="text-stone-600 font-body text-sm mb-3 leading-relaxed">{program.tagline}</p>
          <Link
            to={`/programs/${program.id}`}
            className={`inline-flex items-center gap-2 font-body text-sm font-medium px-5 py-2 rounded-full transition-colors ${unlocked ? 'bg-forest text-cream hover:bg-forest-dark' : 'bg-white border border-stone-300 text-forest hover:border-forest'}`}
            data-testid={`team-enter-${program.id}`}
          >
            {unlocked ? <>Enter <ChevronRight size={15} /></> : <><Lock size={13} /> Members Only</>}
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default function TeamProgramCards() {
  return (
    <div className="grid md:grid-cols-2 gap-6 mb-16" data-testid="team-program-cards">
      {teamPrograms.map((p, i) => <TeamCard key={p.id} program={p} index={i} />)}
    </div>
  );
}
